// extracted by mini-css-extract-plugin
export var dividerLine = "_8k-3";
export var itemImage = "_8k-9";
export var lightDivider = "_8k-4";
export var modalContent = "_8k-5";
export var modalContentCompact = "_8k-6";
export var productCard = "_8k-a";
export var productImage = "_8k-b";
export var productImageCompact = "_8k-7";
export var productImagePlaceholder = "_8k-c";
export var productImagePlaceholderCompact = "_8k-8";
export var progressBarBackground = "_8k-1";
export var progressBarContainer = "_8k-0";
export var progressBarFill = "_8k-2";